(function () {

    var burgers = document.querySelectorAll(".burger");

    burgers.forEach((e) => {
        e.addEventListener("click", () => {
            e.classList.toggle("open");
            const links = e.closest(".mainnav").querySelector(".nav-links")
            links.classList.toggle("show")
        })
    })

})();